/*
 * @Author: zjg
 * @Date: 2020-04-14 15:14:33
 * @LastEditTime: 2020-04-29 17:38:51
 * @Deccription: 全局的状态存储
 */
import Vue from 'vue'
import Vuex from 'vuex'
import { lenovoDataInitState, LenovoDataGetters, lenovoDataMutations } from './modules/m-get-lenovodata'
import { filedataSate, filedataMutations } from './modules/m-get-filedata'
import { previewSate, previewMutations } from './modules/m-get-previewdata'
import { commonSate, commonMutations } from './modules/m-get-common'
import { requestStatus, requestMutations } from './modules/m-get-requests'
import { featureGuideState, featureGuideMutations, featureGuideActions } from './modules/m-get-featureguide'
import { rpanelState, rpanelMutations } from './modules/m-get-rightpanel'
import * as actions from './actions'
import {
  tempFileListState, tempFileListMutations,
} from './modules/m-get-tempfilelist'
import { fileUrlReferenceState, fileUrlReferenceMutations, fileUrlReferenceActions } from './modules/m-quick-access-link'
import { pkgSelectedData, selectedDataMutations, selectedDataGetters } from './modules/m-get-pkg-selectdata'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lenovoData: lenovoDataInitState,
    tempFileListState,
    ...filedataSate,
    ...previewSate,
    ...commonSate,
    ...featureGuideState,
    ...requestStatus,
    rpanelState,
    fileUrlReferenceState,
    pkgSelectedData,
  },
  getters: {
    ...LenovoDataGetters,
    ...selectedDataGetters,
  },
  actions: {
    ...actions,
    ...featureGuideActions,
    ...fileUrlReferenceActions,
  },
  mutations: {
    ...lenovoDataMutations,
    ...filedataMutations,
    ...previewMutations,
    ...commonMutations,
    ...featureGuideMutations,
    ...requestMutations,
    ...rpanelMutations,
    ...tempFileListMutations,
    ...fileUrlReferenceMutations,
    ...selectedDataMutations,
  },
  modules: {
  },
})
